import AnimatedSection from '../common/AnimatedSection'
import { achievementsFutureGoalsIcons } from '../icons/AchievementsFutureGoalsIcons'
import { achievementsFutureGoalsSection } from '../../data/achievementsPageData'

function AchievementsFutureGoalsSection() {
  const { label, titleLine1, titleAccent, goals } = achievementsFutureGoalsSection

  return (
    <AnimatedSection className="achievements-future-goals">
      <div className="container corp-container">
        <header className="achievements-future-goals__head">
          <span className="achievements-future-goals__label">
            <span className="achievements-future-goals__label-bar" aria-hidden="true" />
            {label}
            {/* <span className="achievements-future-goals__label-bar" aria-hidden="true" /> */}
          </span>
          <h2>
            {titleLine1} <span>{titleAccent}</span>
          </h2>
        </header>

        <div className="achievements-future-goals__grid" role="list">
          {goals.map((goal) => {
            const Icon = achievementsFutureGoalsIcons[goal.icon]
            return (
              <article className="achievements-future-goals__item" key={goal.id} role="listitem">
                <span className="achievements-future-goals__icon" aria-hidden="true">
                  <Icon />
                </span>
                <h3>{goal.title}</h3>
                <p>{goal.description}</p>
              </article>
            )
          })}
        </div>
      </div>
    </AnimatedSection>
  )
}

export default AchievementsFutureGoalsSection
